import ValidationUtil from '@/utils/validate'
import { isNumber } from 'lodash'

const presenceFunc = (val) => ValidationUtil._validatePresence(val)
const numberFunc = (val) => ValidationUtil._validateInteger(val)
const positiveFunc = (val) => ValidationUtil._positive(val)
const emailFunc = (val) => ValidationUtil._validateEmail(val)
const blankOrLengthInRangeFunc = (min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) => (val) => val !== undefined && val !== null && val.length === 0 || (val.length >= min && val.length <= max)
const blankOrEmailFunc = (val) => presenceFunc(val) ? emailFunc(val) : true
const blankOrPhoneFunc = (val) => presenceFunc(val) ? ValidationUtil._phone(val) : true
const charLengthValidFunc = (value, fields) => {
  if (!value) return true

  const num = isNumber(value) ? value : parseInt(value, 10)
  if (isNaN(num)) return false

  return num >= fields.prefix.length + fields.suffix.length || num === null
}
const blankOrExactLengthFunc = (size = Number.MAX_SAFE_INTEGER) => (val) => val !== undefined && val !== null && val.length === 0 || (val.length === size)
const alphaNumericFunc = (val) => {
  const regexPattern = /^[a-z0-9]+$/i
  const validRegex = val.match(regexPattern)
  return !val || (val.length === 0) || validRegex
}

export const presence = { messageKey: 'presence', function: presenceFunc }
export const number = { messageKey: 'number', function: numberFunc }
export const positive = { messageKey: 'positive', function: positiveFunc }
export const blankOrLengthInRange = (min, max) => ({ messageKey: 'blankOrLengthInRange', function: blankOrLengthInRangeFunc(min, max) })
export const blankOrEmail = { messageKey: 'blankOrEmail', function: blankOrEmailFunc }
export const blankOrPhone = { messageKey: 'blankOrPhone', function: blankOrPhoneFunc }
export const email = { messageKey: 'email', function: emailFunc }
export const charLengthValid = {
  messageKey: 'charLengthValid',
  function: charLengthValidFunc
}
export const blankOrExactLength = (size) => ({ messageKey: 'blankOrExactLength', function: blankOrExactLengthFunc(size) })
export const alphaNumeric = { messageKey: 'alphaNumeric', function: alphaNumericFunc }
